import React from 'react';
import styles from './GettingStarted.module.css';
import I18N from '../classes/I18N';
import translations from '../lang/components/GettingStartedPanel.lang.json';

const i18n = new I18N(translations);

class GettingStartedPanel extends React.Component {
    render() {
      return (
        <div className={styles.gettingStartedContainer}>
            <img alt={i18n.t(this.props.locale, 'rocketShipAlt')} src="../getting-started-stock.svg" />
            <span className={styles.gettingStarted}>{i18n.t(this.props.locale, 'gettingStarted')}</span>
            <p>{i18n.t(this.props.locale, 'gettingStartedP1')}</p>
            <p>{i18n.t(this.props.locale, 'gettingStartedP2')} →</p>
        </div>
      );
    }
  }

  export default GettingStartedPanel;
